import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService, GET, Adapter } from "@royalty/httpclient";

@Injectable()
export class RestaurantService extends HttpService {
	@GET("restaurant/info")
	@Adapter(null, { isAdmin: false })
	getRestaurantInfo(): Observable<any> {
		return null;
	}
}
